import {route, string} from 'react-router-typesafe-routes';

export const questionnairesRoutesPath = route({
  children: {
    questionnaire: route({
      children: {
        create: route({
          path: 'create',
        }),
        edit: route({
          path: 'edit',
          searchParams: {
            id: string().defined(),
          },
        }),
        template: route({
          children: {
            create: route({
              path: 'create',
            }),
            questions: route({
              path: 'questions',
            }),
          },
          path: 'template',
        }),
        view: route({
          children: {
            questions: route({
              path: 'questions',
            }),
            status: route({
              path: 'status',
            }),
          },
          path: 'view',
          searchParams: {
            id: string().defined(),
          },
        }),
      },
      path: 'questionnaire',
    }),
    userQuestionnaire: route({
      children: {
        about: route({
          path: 'about',
        }),
        progress: route({
          path: 'progress',
        }),
      },
      path: 'user-questionnaire',
      searchParams: {
        id: string().defined(),
      },
    }),
  },
});
